// extracted by mini-css-extract-plugin
module.exports = {"rootStyles":"Rating_rootStyles__3l7ef","rating":"Rating_rating__3LEfv"};